import Mustache from 'mustache'
import { useParams } from 'react-router-dom'

import { useHtmls } from '../../api/htmls'

export function getHtml(key = '', htmls = []) {
  const html = htmls.find((h) => h.key === key)
  if (!html) {
    return `Missing key: '${key}'`
  }

  if (!html.value) {
    return `Missing value for key: '${key}'`
  }

  return html.value
}

export function mustache(template, data) {
  return Mustache.render(template, data)
}

export const Html = ({ name, isLoading, htmls, data }) => {
  if (isLoading) return null

  const template = getHtml(name, htmls)

  return (
    <span>
      <div
        id={name}
        className="html-content"
        dangerouslySetInnerHTML={{
          __html: mustache(template, data),
        }}
      />
    </span>
  )
}

export const HtmlConnected = ({ name, data }) => {
  const { projectId } = useParams()
  const { data: htmls, isLoading } = useHtmls(projectId)
  return (
    <Html name={name} htmls={htmls || []} isLoading={isLoading} data={data} />
  )
}
